var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hide Eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1_Signin_04",
    transform: "translate(-1105.000000, -522.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(693.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(48.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(52.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password",
    transform: "translate(0.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323,41.5 C318,41.5 313.73,44.61 312,49 C313.73,53.39 318,56.5 323,56.5 C328,56.5 332.27,53.39 334,49 C332.27,44.61 328,41.5 323,41.5 Z M323,54 C320.24,54 318,51.76 318,49 C318,46.24 320.24,44 323,44 C325.76,44 328,46.24 328,49 C328,51.76 325.76,54 323,54 Z M323,46 C321.34,46 320,47.34 320,49 C320,50.66 321.34,52 323,52 C324.66,52 326,50.66 326,49 C326,47.34 324.66,46 323,46 Z",
    id: "Hide-Eye"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEye);
export default __webpack_public_path__ + "static/media/HideEye.148c0a513190f4c53feb254eb60f69ba.svg";
export { ForwardRef as ReactComponent };